import React from 'react';
import '../styles/pages/login.scss';
import LoginComponent from '../components/login/Login';

export default function Login() {
  return <LoginComponent />;
}
